import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    style={{ minWidth: 24 }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    onClick={disabled ? null : onClick}
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
  >
    <path
      id="svg_1"
      fill={color ? color : disabled ? "#4D4D4D" : "#000"}
      d="m12,4.91495c1.09,-1.28 2.76,-2.09 4.5,-2.09c3.08,0 5.5,2.42 5.5,5.5c0,3.77685 -3.3944,6.85495 -8.5373,11.51855l-0.0127,0.0115l-1.45,1.32l-1.45,-1.31l-0.0395,-0.0359c-5.12787,-4.6599 -8.5105,-7.7338 -8.5105,-11.50415c0,-3.08 2.42,-5.5 5.5,-5.5c1.74,0 3.41,0.81 4.5,2.09z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </svg>
);
